export default __webpack_public_path__ + "static/media/github_logo.07f6d2e9.png";